module.exports = __webpack_public_path__ + "static/media/share.d1c7a51b.svg";